module.exports = __webpack_public_path__ + "static/media/temenos.a24cba8a.png";